import React from 'react'

function Stock ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 24 24'>
      <path d='M96,202.668h13.2v1.2H96Zm0,0' transform='translate(-90.6 -191.268)' />
      <path d='M202.668,96h1.2v13.2h-1.2Zm0,0' transform='translate(-191.268 -90.6)' />
      <path d='M21.6,24H2.4A2.407,2.407,0,0,1,0,21.6V2.4A2.407,2.407,0,0,1,2.4,0H21.6A2.407,2.407,0,0,1,24,2.4V21.6A2.407,2.407,0,0,1,21.6,24ZM2.4,1.2A1.2,1.2,0,0,0,1.2,2.4V21.6a1.2,1.2,0,0,0,1.2,1.2H21.6a1.2,1.2,0,0,0,1.2-1.2V2.4a1.2,1.2,0,0,0-1.2-1.2Zm0,0' />
    </svg>
  )
}

Stock.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Stock
